<template>
  <div class="proxy-container">
    <!-- 頭部 -->
    <div class="header">
      <h2 class="title">代理中心</h2>
    </div>

    <div style="position: fixed; top: 30px; left: 30px;">
      <el-button icon="el-icon-arrow-left" @click="close" class="back-btn" plain size="small"></el-button>
    </div>
    <!-- {{ UserInfoData }} -->
    <!-- 主要內容 -->
    <div class="content-container">
      <!-- 邀請連結 -->
      <!-- <div class="card-box glow-card"> -->
      <div class="card-title">
        <i class="el-icon-link"></i>
        邀請連結
      </div>
      <div class="share-container">
        <el-input v-model="shareUrl" readonly class="share-input" style="flex:1"
          :class="{ 'copied-effect': showCopyEffect }">
          <el-button slot="append" icon="el-icon-document-copy" @click="copyUrl" class="copy-btn"
            :type="showCopyEffect ? 'success' : 'primary'">
          </el-button>
        </el-input>
      </div>
      <!-- </div> -->

      <!-- 傭金信息 -->
      <div class="stats-container">
        <div class="stats-card gradient-bg">
          <div class="stats-icon">
            <i class="el-icon-coin"></i>
          </div>
          <div class="stats-content">
            <!-- {{ UserInfoData }} -->
            <div class="stats-label">累計佣金 (默認 {{ UserInfoData.proxy_avg }}%)</div>
            <div class="stats-value">HKD {{ Number(UserInfoData.proxy_balance / 100).toFixed(2) }}</div>
          </div>
        </div>
      </div>

      <div @click="withdraw()"
        style="text-align: center; padding: 14px 0; text-align: center; color: #3E4F7A; border-radius: 100px; margin: 30px 0; border: 1px solid #3E4F7A;">
        申请提现
      </div>

      <!-- 用戶列表 -->
      <div class="card-box">
        <div class="card-title">
          <i class="el-icon-s-order"></i>
          提现申请
        </div>
        <!-- {{ withdrawData }} -->
        <el-table :data="withdrawData" class="data-table" v-loading="loading.consumptions"
          header-row-class-name="table-header">
          <el-table-column prop="create_at" label="時間">
            <template slot-scope="scope">
              {{ formatTimestamp(scope.row.proxy_withdraw_order.create_at) }}
            </template>
          </el-table-column>
          <el-table-column prop="user" label="状态">
            <template slot-scope="scope">
              <div class="user-cell">
                <span v-if="scope.row.proxy_withdraw_order.status === 0" style="color: orange; font-weight: 800;">待审核</span>
                <span v-if="scope.row.proxy_withdraw_order.status === 1" style="color: green; font-weight: 800;">已到账</span>
                <span v-if="scope.row.proxy_withdraw_order.status === 2" style="color: red; font-weight: 800;">已驳回</span>
                <span v-if="scope.row.proxy_withdraw_order.status === 3" style="color: black; font-weight: 800;">已拒绝</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="金額" align="right">
            <template slot-scope="scope">
              HKD {{ Number(scope.row.proxy_withdraw_order.amount / 100).toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 用戶列表 -->
      <div class="card-box">
        <div class="card-title">
          <i class="el-icon-user-solid"></i>
          代理用戶（{{ users.length }}人）
        </div>
        <el-table :data="users" class="data-table" v-loading="loading.users" header-row-class-name="table-header">
          <el-table-column label="用戶">
            <template slot-scope="scope">
              <div class="user-cell">
                <el-avatar :size="28" :src="'/api/file/download/' + scope.row.to_user.img"
                  class="user-avatar"></el-avatar>
                <span>{{ scope.row.to_user.nick }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="分傭比例">
            <template slot-scope="scope">
              {{ scope.row.proxy_link.avg }}%
            </template>
          </el-table-column>
          <el-table-column prop="register_time" label="註冊時間">
            <template slot-scope="scope">
              {{ formatTimestamp(scope.row.to_user.create_at) }}
            </template>
          </el-table-column>

        </el-table>
      </div>

      <!-- 消費記錄 -->
      <div class="card-box">
        <div class="card-title">
          <i class="el-icon-s-order"></i>
          消費記錄
        </div>
        <el-table :data="consumptions" class="data-table" v-loading="loading.consumptions"
          header-row-class-name="table-header">
          <el-table-column prop="create_at" label="時間">
            <template slot-scope="scope">
              {{ formatTimestamp(scope.row.proxy_log.create_at) }}
            </template>
          </el-table-column>
          <el-table-column prop="user" label="用戶">
            <template slot-scope="scope">
              <div class="user-cell">
                <el-avatar :size="28" :src="'/api/file/download/' + scope.row.to_user.img"
                  class="user-avatar"></el-avatar>
                <span>{{ scope.row.to_user.nick }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="金額" align="right">
            <template slot-scope="scope">
              HKD {{ Number(scope.row.proxy_log.money / 100).toFixed(2) }}
              <!-- <span class="amount-number">{{ formatTimestamp(scope.row.create_at) }}</span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProxyCenter",
  data() {
    return {
      shareUrl: "",
      commission: 0,
      users: [],
      usersCount: 0,
      consumptions: [],
      showCopyEffect: false,
      copyButtonText: '一鍵複製',
      loading: {
        users: true,
        consumptions: true
      },
      UserInfoData: {},
      withdrawData: []
    }
  },
  mounted() {
    // 刷新用戶信息
    this.refreshUser()


  },
  methods: {
    formatTimestamp(timestamp, format = 'YYYY-MM-DD HH:mm:ss', isSeconds = true) {
      // 處理秒級時間戳
      const ts = isSeconds ? timestamp * 1000 : timestamp;
      const date = new Date(ts);

      // 時間元素提取
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份從0開始計算
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      // 補零函數
      const pad = n => n.toString().padStart(2, '0');

      // 格式替換
      return format
        .replace(/YYYY/g, year)
        .replace(/MM/g, pad(month))
        .replace(/DD/g, pad(day))
        .replace(/HH/g, pad(hours))
        .replace(/mm/g, pad(minutes))
        .replace(/ss/g, pad(seconds));
    },
    getWithdrawData() {
      this.$axios.get("/api/proxy_order/list").then(res => {
        let d = res.data.data.items

        this.withdrawData = d
      })
    },
    withdraw() {
      this.$router.push({
        name: 'Withdraw'
      });
    },
    ProxyLog() {
      this.$axios.get("/api/proxy_log/list").then(res => {
        this.consumptions = res.data.data.items

        this.loading.consumptions = false
      })
    },
    refreshUser() {
      this.$axios.get("/api/user/info").then(res => {
        this.UserInfoData = res.data.data
        this.shareUrl = `${window.location.protocol}//${window.location.host}?share=${res.data.data.id}`

        // 獲取代理用戶
        this.GetToUsers()

        // 獲取消費記錄
        this.ProxyLog()

        // 获取提现记录
        this.getWithdrawData()
      })
    },
    GetToUsers() {
      this.$axios.get("/api/proxy_link/list").then(res => {
        let d = res.data.data

        this.usersCount = d.total
        this.users = d.items

        this.loading.users = false
      })
    },
    close() {
      this.$router.go(-1);
    },
    async copyUrl() {
      try {
        await navigator.clipboard.writeText(this.shareUrl);
        this.showCopyEffect = true;
        this.copyButtonText = '已複製';
        this.$message.success('連結已複製到剪貼板');
        setTimeout(() => {
          this.showCopyEffect = false;
          this.copyButtonText = '一鍵複製';
        }, 2000);
      } catch (error) {
        this.$message.error('複製失敗，請手動選擇複製');
      }
    },
    formatNumber(num) {
      return Number(num).toLocaleString();
    },
  }
}
</script>

<style scoped>
.proxy-container {
  padding: 16px;
  max-width: 800px;
  margin: 0 auto;
}

.header {
  padding: 16px 0;
  margin-bottom: 20px;
}

.title {
  text-align: center;
  color: #3E4F7A;
  margin: 0;
  font-size: 20px;
  letter-spacing: 1px;
}

.content-container {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* 卡片樣式 */
.card-box {
  margin-bottom: 24px;
  background: #fff;
  border-radius: 12px;
  padding: 20px 0;
  transition: transform 0.2s;
}

.card-box:hover {
  transform: translateY(-2px);
}

.card-title {
  color: #3E4F7A;
  font-weight: 600;
  margin-bottom: 20px;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 邀請連結 */
.share-container {
  display: flex;
  gap: 12px;
  align-items: center;
}

.share-input {
  transition: all 0.3s;
}

.share-input.copied-effect {
  box-shadow: 0 0 0 2px #67C23A;
}

.copy-btn {
  border-radius: 0 8px 8px 0 !important;
  padding: 12px 20px !important;
  transition: all 0.3s;
}

/* 統計卡片 */
.stats-container {
  margin: 24px 0;
}

.stats-card {
  background: #3E4F7A;
  border-radius: 12px;
  padding: 24px;
  color: white;
  display: flex;
  align-items: center;
  gap: 20px;
}

.stats-icon {
  font-size: 32px;
  background: rgba(255, 255, 255, 0.2);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stats-label {
  font-size: 14px;
  opacity: 0.9;
}

.stats-value {
  font-size: 28px;
  font-weight: 700;
  margin-top: 8px;
}

/* 表格樣式 */
.data-table {
  border-radius: 8px;
  overflow: hidden;
}

.user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  flex-shrink: 0;
}

.amount-number {
  font-family: 'Roboto Mono', monospace;
  font-weight: 500;
}

/* 全局樣式調整 */
.el-input>>>.el-input__inner {
  height: 48px;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

.el-table>>>.table-header th {
  background: #f8fafc;
  color: #64748b;
  font-weight: 600;
}

.el-table>>>td {
  padding: 14px 0;
}

.gradient-bg {
  background: linear-gradient(135deg, #3E4F7A 0%, #2c3a58 100%);
}

.glow-card {
  box-shadow: 0 4px 24px rgba(62, 79, 122, 0.1);
}
</style>
